import React from 'react';
import PropTypes from 'prop-types';
import { Cover, Line, Overlay } from './style';

const Statistics = ({ data, background }) => {
  return (
    <Cover src={background}>
      <Overlay>
        <div>
          <p>+{data.totalCourses}</p>Corsi e moduli disponibili su Sisfor+
        </div>
        <div>
          <p>{data?.totalNumberOfFFOO}</p>
          Forze dell'ordine
        </div>
        <Line />
        <div>
          <p>{Number(data.totalActiveUsers || '0').toLocaleString('it-IT')}</p>
          Utenti attivi
        </div>
        <Line />
        <div>
          <p>{data.totalCategories}</p> Aree Tematiche
        </div>
      </Overlay>
    </Cover>
  );
};

Statistics.propTypes = {
  data: PropTypes.object,
  background: PropTypes.string,
};

export default Statistics;
